import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: "",
  messageType: "danger",
  isVisible: false,
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload.message || action.payload;
      state.messageType = action.payload.messageType || "danger";
      state.isVisible = true;
    },
    setSuccessMessage: (state, action) => {
      state.message = action.payload;
      state.messageType = "success";
      state.isVisible = true;
    },
    setErrorMessage: (state, action) => {
      state.message = action.payload;
      state.messageType = "danger";
      state.isVisible = true;
    },
    setWarningMessage: (state, action) => {
      state.message = action.payload;
      state.messageType = "warning";
      state.isVisible = true;
    },
    setInfoMessage: (state, action) => {
      state.message = action.payload;
      state.messageType = "info";
      state.isVisible = true;
    },
    clearMessage: (state) => {
      state.message = "";
      state.messageType = "danger";
      state.isVisible = false;
    },
  },
});

// Export actions
export const {
  setMessage,
  setSuccessMessage,
  setErrorMessage,
  setWarningMessage,
  setInfoMessage,
  clearMessage,
} = messageSlice.actions;

// Export selectors
export const selectMessage = (state) => state.message.message;
export const selectMessageType = (state) => state.message.messageType;
export const selectIsMessageVisible = (state) => state.message.isVisible;
export const selectMessageState = (state) => state.message;

// Export reducer
export default messageSlice.reducer;
